import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="py-16 px-4 bg-gradient-to-br from-dance-navy to-dance-navy/90">
      <div className="max-w-6xl mx-auto text-center">
        {/* Full Logo */}
        <div className="mb-8">
          <img 
            src="/images/tdflogodancers.svg" 
            alt="The Dance Floor - A Dancer's Home" 
            className="h-16 md:h-20 mx-auto filter brightness-0 invert"
          />
        </div>
        
        <div className="border-t border-white/20 pt-8">
          <p className="text-white/80 text-sm mb-4">
            © 2024 The Dance Floor - A Dancer's Home. All rights reserved.
          </p>
          <p className="text-white/60 text-xs">
            Austin's premier destination for ballroom, latin, and social dance
          </p>
          <p className="text-white/60 text-xs">
            Website designed by <a href="https://sethlowery.me" className="text-white/60 hover:text-white">Seth Lowery</a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
